import FormNumberInput from '@/components/UI/FormNumberInput';

interface PopulationPriorityInputProps {
    id: string;
    priority: number;
    onChange: (priority: number) => void;
    noMargin?: boolean;
}

const clampPriority = (priority: number): number => Math.max(1, Math.min(10, Math.trunc(priority)));

const PopulationPriorityInput = ({ id, priority, onChange, noMargin = true }: PopulationPriorityInputProps) => (
    <FormNumberInput
        integer
        helpText="Higher numbers run sooner. Priority 10 is highest; the normal queue priority is 5."
        id={id}
        label="Queue priority"
        max={10}
        min={1}
        noMargin={noMargin}
        value={priority}
        onValueChange={(value) => {
            // A queued population always carries a priority, so an empty field keeps the current one.
            if (value === null) return;

            onChange(clampPriority(value));
        }}
    />
);

export default PopulationPriorityInput;
